type IframeHeightMixinThis = {
  $refs: {
    horsePage?: HTMLElement;
  };
  $nextTick: (callback: () => void) => void;
};

const MESSAGE_TYPE = "iframe-horse-height";
const ROUTE_UPDATE_DELAY = 300;
const LOG_PREFIX = "[IframeHeight]";

let currentHeight = 0;
let animationFrame: number | null = null;
let observer: MutationObserver | null = null;

const getContentHeight = (element: HTMLElement): number => {
  const previousMinHeight = element.style.minHeight;
  element.style.minHeight = "0px";
  const height = Math.ceil(element.scrollHeight);
  element.style.minHeight = previousMinHeight;
  return height;
};

const updateHeight = (element?: HTMLElement, minHeight: number | null = null): void => {
  if (!element) return;

  const contentHeight = getContentHeight(element);
  const nextHeight = minHeight && minHeight > contentHeight ? minHeight : contentHeight;

  if (nextHeight > 0 && nextHeight !== currentHeight) {
    currentHeight = nextHeight;
    window.parent.postMessage({ type: MESSAGE_TYPE, height: nextHeight }, "*");
  }
};

const queueUpdateHeight = (element?: HTMLElement, minHeight: number | null = null): void => {
  if (animationFrame) {
    cancelAnimationFrame(animationFrame);
  }

  animationFrame = requestAnimationFrame(() => {
    animationFrame = null;
    updateHeight(element, minHeight);
  });
};

const destroyObserver = (): void => {
  observer?.disconnect();
  observer = null;

  if (animationFrame) {
    cancelAnimationFrame(animationFrame);
    animationFrame = null;
  }
};

export default {
  mounted(this: IframeHeightMixinThis): void {
    const element = this.$refs.horsePage;
    if (!element) {
      return;
    }

    destroyObserver();

    observer = new MutationObserver((mutations) => {
      const hasContentChange = mutations.some(
        (mutation) =>
          !(
            mutation.type === "attributes" &&
            mutation.target === element &&
            mutation.attributeName === "style"
          )
      );

      if (!hasContentChange) return;

      queueUpdateHeight(element);
    });

    observer.observe(element, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    queueUpdateHeight(element);
  },

  beforeDestroy(): void {
    destroyObserver();
  },

  watch: {
    "$route.fullPath"(this: IframeHeightMixinThis): void {
      this.$nextTick(() => {
        currentHeight = 0;
        queueUpdateHeight(this.$refs.horsePage);
        setTimeout(() => queueUpdateHeight(this.$refs.horsePage), ROUTE_UPDATE_DELAY);
      });
    },
  },
};
